var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApiClient } from "@/context/ApiClientContext";
import { filterProducts, sortProducts } from "@/utils/dataProcessing";
import DOMPurify from "dompurify";
import "./ProductCatalog.css";
import "@/pages/home/HomePage.css";
import { useCart } from "@/context/CartContext";
import { FaShoppingCart, FaTimes, FaAngleLeft, FaAngleRight, } from "react-icons/fa";
const ProductCatalog = ({ categoryId, propsProducts, propsLimit = 20, propsApiSort, propsSort = "name-asc", filterMinPrice, filterMaxPrice, filterDiscountOnly = false, itemsPerPage = 12, onResetFilters, }) => {
    const apiClient = useApiClient();
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { cartItems, addToCart, removeFromCart } = useCart();
    const [currentPage, setCurrentPage] = useState(1);
    useEffect(() => {
        setCurrentPage(1);
        if (onResetFilters) {
            onResetFilters();
        }
    }, [propsSort, filterMinPrice, filterMaxPrice, filterDiscountOnly]);
    useEffect(() => {
        const fetchProducts = () => __awaiter(void 0, void 0, void 0, function* () {
            if (categoryId) {
                try {
                    setLoading(true);
                    const response = yield apiClient.searchData("category", categoryId);
                    const data = response;
                    setFilteredProducts(data);
                    setError(null);
                }
                catch (err) {
                    setError(err.message);
                }
                finally {
                    setLoading(false);
                }
            }
            else if (propsProducts) {
                setFilteredProducts(propsProducts);
                setLoading(false);
            }
            else {
                try {
                    setLoading(true);
                    // GET PRODUCTS FROM API
                    const arg = {
                        limit: propsLimit,
                        sort: propsApiSort,
                    };
                    const { products: data } = yield apiClient.getAllProducts(arg);
                    // SORT PRODUCTS DATA
                    const sortedData = sortProducts(data, propsSort);
                    // FILTER PRODUCTS DATA
                    const filterArg = {
                        minPrice: filterMinPrice,
                        maxPrice: filterMaxPrice,
                        discountOnly: filterDiscountOnly,
                    };
                    const filteredData = filterProducts(sortedData, filterArg);
                    setFilteredProducts(filteredData);
                    setError(null);
                }
                catch (err) {
                    setError(err.message);
                }
                finally {
                    setLoading(false);
                }
            }
        });
        fetchProducts();
    }, [
        categoryId,
        apiClient,
        propsProducts,
        propsSort,
        propsLimit,
        propsApiSort,
        filterMinPrice,
        filterMaxPrice,
        filterDiscountOnly,
    ]);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredProducts.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
    const goToPrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
    const goToNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const isProductInCart = (productId) => {
        return cartItems.some((item) => item.productId === productId);
    };
    if (loading)
        return _jsx("div", { className: "loading-container", children: "Loading..." });
    if (error)
        return _jsxs("div", { className: "main-container", children: ["Error: ", error] });
    if (filteredProducts.length === 0) {
        return (_jsx("div", { className: "main-container", children: _jsx("p", { className: "no-found", children: "No products were found matching your filters." }) }));
    }
    return (_jsxs("div", { className: "product-catalog-container", children: [_jsx("div", { className: "cards-container", children: currentItems.map((product) => {
                    const inCart = isProductInCart(product.id);
                    return (_jsxs("div", { className: "cards-item", children: [_jsxs(Link, { to: "/product/" + product.key, children: [_jsx("div", { className: "cards-item-img", children: product.images && product.images.length > 0 ? (_jsx("img", { src: product.images[0].url, alt: product.name })) : (_jsx("div", { className: "no-image-placeholder", children: "No Image" })) }), _jsx("div", { className: "cards-item-name cards-item-text", children: product.name }), _jsx("div", { className: "cards-item-desc cards-item-text", children: _jsx("div", { dangerouslySetInnerHTML: {
                                                __html: DOMPurify.sanitize(product.description).slice(0, 55) +
                                                    "...  ",
                                            } }) }), _jsx("div", { className: "product-price-container", children: product.priceDiscounted ? (_jsxs("div", { className: "price-with-discount", children: [_jsxs("span", { className: "price-discounted", children: [product.priceDiscounted, " \u20AC"] }), _jsxs("span", { className: "price-original", children: [product.price, " \u20AC"] })] })) : (_jsxs("span", { className: "price-regular", children: [product.price, " \u20AC"] })) })] }), _jsx("div", { className: "cards-item-card cards-item-text", children: inCart ? (_jsxs("button", { className: "button__removeFromCart", onClick: (e) => {
                                        e.preventDefault();
                                        removeFromCart(product.id);
                                    }, children: [_jsx(FaTimes, {}), " REMOVE FROM CART"] })) : (_jsxs("button", { className: "button__addToCart", onClick: (e) => {
                                        e.preventDefault();
                                        addToCart(product.id, 1);
                                    }, children: [_jsx(FaShoppingCart, {}), "ADD TO CART"] })) })] }, product.id));
                }) }), filteredProducts.length > itemsPerPage && (_jsxs("div", { className: "pagination-container", children: [_jsx("button", { onClick: goToPrevPage, disabled: currentPage === 1, className: "pagination-button", "aria-label": "Previous page", children: _jsx(FaAngleLeft, {}) }), _jsxs("span", { className: "current-page-indicator", children: ["Page ", currentPage, " of ", totalPages] }), _jsx("button", { onClick: goToNextPage, disabled: currentPage === totalPages, className: "pagination-button", "aria-label": "Next page", children: _jsx(FaAngleRight, {}) })] }))] }));
};
export default ProductCatalog;
